<template>
   <div
      v-if="text"
      class="rounded-small flex items-center gap-1 px-2 py-1"
      :class="{
         'bg-green': type === 'success',
         'bg-yellow': type === 'warning',
         'bg-red': type === 'error',
         'bg-primary': type === 'primary',
         'bg-gold': type === 'gold',
         'bg-light-blue': type === 'light-blue',
         'bg-light-grey': type === 'light-grey',
      }"
   >
      <Icon
         v-if="icon"
         :name="icon"
         :class="{
            'text-primary':
               type === 'success' ||
               type === 'warning' ||
               type === 'light-blue' ||
               type === 'light-grey',
            'text-white': type === 'error' || type === 'gold',
            'text-secondary': type === 'primary',
         }"
      />
      <p
         class="h-s"
         :class="{
            uppercase: uppercase,
            'text-primary':
               type === 'success' ||
               type === 'warning' ||
               type === 'light-blue' ||
               type === 'light-grey',
            'text-white': type === 'error' || type === 'gold',
            'text-secondary': type === 'primary',
         }"
      >
         {{ text }}
      </p>
   </div>
</template>

<script lang="ts" setup>
type Props = {
   icon?: string
   text?: string
   type?: 'success' | 'warning' | 'error' | 'primary' | 'gold' | 'light-blue' | 'light-grey'
   uppercase?: boolean
}

const props = withDefaults(defineProps<Props>(), {
   uppercase: true,
   type: 'primary',
})
</script>
